import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OrganizationMember } from '@/types/models';

interface Organization {
  id: string;
  name: string;
  slug: string;
  trial_mode: boolean;
  asset_limit: number;
  current_asset_count: number;
}

interface OrgState {
  currentOrg: Organization | null;
  currentMembership: OrganizationMember | null;
  isLoading: boolean;
  hasHydrated: boolean;
}

interface OrgActions {
  setOrganization: (org: Organization | null, membership: OrganizationMember | null) => void;
  setLoading: (isLoading: boolean) => void;
  clearOrganization: () => void;
  setHasHydrated: (hasHydrated: boolean) => void;
}

type OrgStore = OrgState & OrgActions;

export const useOrgStore = create<OrgStore>()(
  persist(
    (set) => ({
      // State
      currentOrg: null,
      currentMembership: null,
      isLoading: false,
      hasHydrated: false,

      // Actions
      setOrganization: (org, membership) =>
        set({
          currentOrg: org,
          currentMembership: membership,
          isLoading: false,
        }),

      setLoading: (isLoading) => set({ isLoading }),

      setHasHydrated: (hasHydrated) => set({ hasHydrated }),

      clearOrganization: () =>
        set({
          currentOrg: null,
          currentMembership: null,
          isLoading: false,
        }),
    }),
    {
      name: 'org-storage',
      partialize: (state) => ({
        // Only persist org data, not loading state
        currentOrg: state.currentOrg,
        currentMembership: state.currentMembership,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
